import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "valid-content",
  "use": "valid-content-usage",
  "viewBox": "0 0 241 241",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 241 241\" id=\"valid-content\"><g data-name=\"Layer 2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"13\"><circle cx=\"120.5\" cy=\"120.5\" r=\"113.54\" fill=\"#fff\" /><path fill=\"none\" d=\"M87 126.21l21.13 21.22L158 97.58\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol